/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentScopeEnum } from './DocumentScopeEnum';
import {
    DocumentScopeEnumFromJSON,
    DocumentScopeEnumFromJSONTyped,
    DocumentScopeEnumToJSON,
    DocumentScopeEnumToJSONTyped,
} from './DocumentScopeEnum';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';
import type { GenericColors } from './GenericColors';
import {
    GenericColorsFromJSON,
    GenericColorsFromJSONTyped,
    GenericColorsToJSON,
    GenericColorsToJSONTyped,
} from './GenericColors';

/**
 * 
 * @export
 * @interface GenericDocumentDto
 */
export interface GenericDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof GenericDocumentDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GenericDocumentDto
     */
    label: string;
    /**
     * 
     * @type {Date}
     * @memberof GenericDocumentDto
     */
    creationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GenericDocumentDto
     */
    signatureDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GenericDocumentDto
     */
    storedFileId?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericDocumentDto
     */
    statusLabel?: string;
    /**
     * 
     * @type {GenericColors}
     * @memberof GenericDocumentDto
     */
    statusColor?: GenericColors;
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof GenericDocumentDto
     */
    fileType: FileTypeEnum;
    /**
     * 
     * @type {DocumentScopeEnum}
     * @memberof GenericDocumentDto
     */
    scope: DocumentScopeEnum;
    /**
     * 
     * @type {number}
     * @memberof GenericDocumentDto
     */
    version: number;
}



/**
 * Check if a given object implements the GenericDocumentDto interface.
 */
export function instanceOfGenericDocumentDto(value: object): value is GenericDocumentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function GenericDocumentDtoFromJSON(json: any): GenericDocumentDto {
    return GenericDocumentDtoFromJSONTyped(json, false);
}

export function GenericDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenericDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'creationDate': (new Date(json['creationDate'])),
        'signatureDate': json['signatureDate'] == null ? undefined : (new Date(json['signatureDate'])),
        'storedFileId': json['storedFileId'] == null ? undefined : json['storedFileId'],
        'statusLabel': json['statusLabel'] == null ? undefined : json['statusLabel'],
        'statusColor': json['statusColor'] == null ? undefined : GenericColorsFromJSON(json['statusColor']),
        'fileType': FileTypeEnumFromJSON(json['fileType']),
        'scope': DocumentScopeEnumFromJSON(json['scope']),
        'version': json['version'],
    };
}

export function GenericDocumentDtoToJSON(json: any): GenericDocumentDto {
    return GenericDocumentDtoToJSONTyped(json, false);
}

export function GenericDocumentDtoToJSONTyped(value?: GenericDocumentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'creationDate': ((value['creationDate']).toISOString().substring(0,10)),
        'signatureDate': value['signatureDate'] == null ? undefined : ((value['signatureDate']).toISOString().substring(0,10)),
        'storedFileId': value['storedFileId'],
        'statusLabel': value['statusLabel'],
        'statusColor': GenericColorsToJSON(value['statusColor']),
        'fileType': FileTypeEnumToJSON(value['fileType']),
        'scope': DocumentScopeEnumToJSON(value['scope']),
        'version': value['version'],
    };
}

